import { ReactNode } from "react";
import { ZPlanning2Row } from "../../ZPlanning2Row";

export type Planning2ColumnKey =
  | "@selection"
  | "actualEndDate"
  | "actualStartDate"
  | "delay"
  | "department"
  | "duration"
  | "durationEstimation"
  | "employee"
  | "forecastEndDate"
  | "forecastStartDate"
  | "name"
  | "plannedEndDate"
  | "plannedStartDate"
  | "priority"
  | "state"
  | "state";

export type Planning2Column = {
  key: Planning2ColumnKey;
  title: ReactNode;
  width: number;
  render: (col: Planning2Column, row: ZPlanning2Row) => ReactNode;
};

// Минимальная ширина колонки таблицы КП
export const planning2MinColumnWidth = 102;
